import { render, staticRenderFns } from "./UiPaymentMethods.vue?vue&type=template&id=32cd043a&"
import script from "./UiPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./UiPaymentMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports